<template></template>

<script>
import Plyr from 'plyr';

export default {
    name: 'videoplyr',
    props:['controls', 'autoplay', 'muted', 'loop'],

    mounted() {
        const player = new Plyr(this.$refs.player, {
            controls: this.controls,
            autoplay: this.autoplay,
            muted: this.muted,
            loop: {
                active: this.loop
            }
        });
    }
}
</script>
